import store from '@/store';
import Taro from '@tarojs/taro';
import { handleCreateProject } from '@/pages/landingPage/common';
import { convertBase64UrlToBlob, createUUID } from '&/utils/common';
import { commentAdjunctView } from '@/api/common';
import { getUserInfo } from '@/api/user';
import { IOSSystemStr } from '@/constants';
import html2canvas from 'html2canvas';

const BLANK_LIST = [
    'landingPage',
    'DownloadFile',
    'DesignShare',
    '/app/hddesign/',
    '/app/hddesign_stagtest/',
    '/hdd/panoramaShare',
    'ReceiveWelfare',
    'panoramaExample',
    'appOutLink'
];

const getTimeStr = (timeUx, time, year) => {
    if (!timeUx) return '';
    let date = new Date(timeUx);
    let Y = date.getFullYear() + '-';
    let M =
        (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1) + '-';
    let D = date.getDate() + ' ';
    let h = date.getHours().toString().padStart(2, '0');
    let m = date.getMinutes().toString().padStart(2, '0');
    let s = date.getSeconds().toString().padStart(2, '0');
    let str = Y + M + D + h + ':' + m + ':' + s;
    if (time) {
        return h + ':' + m;
    } else if (year) {
        return Y + M + D + h + ':' + m;
    }

    return str;
};

function fnTime(time) {
    let ptime = time;

    const twentyFourHours = 24 * 60 * 60 * 1000;
    // const fortyEightHours = 24 * 60 * 60 * 1000 * 2;
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const today = `${year}/${month}/${day}`;
    const todayTime = new Date(today).getTime();
    const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
    // const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime();

    if (ptime >= todayTime) {
        return getTimeStr(time, true);
    } else if (ptime < todayTime && yesterdayTime <= ptime) {
        return intl.get('commonUtils.tomorrow', {
            time: getTimeStr(time, true),
        });
    }
    // else if( ptime < yesterdayTime && lastYesterdayTime <= ptime ){
    //     return '前天 '+time.split(' ')[1];
    // }
    else {
        return getTimeStr(time, false, true);
    }
}

const getTimeStrFormat = timeUx => {
    if (!timeUx) return '';
    return fnTime(timeUx);
};

function getSynergyUrl(isInitPdfView) {
    if (process.env.NODE_ENV === 'development') {
        if (isInitPdfView) {
            return `/api${SYNERGY_URL}`;
        } else {
            return SYNERGY_URL;
        }
    }
    return `${origin}/synergy`;
}

function getPayWsUrl() {
    if (process.env.NODE_ENV === 'development') {
        return REACT_APP_PAY_WS;
    }
    return `wss://${window.location.host}/ws`;
}

export const debounce = (fn, wait = 100) => {
    let timer = null;
    return function () {
        let ctx = this,
            args = arguments;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(ctx, args);
        }, wait);
    };
};

function getFileBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
        return `https://${process.env.HW_OSS_URL}/`;
    } else {
        return (
            window.location.protocol + process.env.REACT_APP_HW_OSS_URL + '/'
        );
    }
}

function handleLogin(cb, redirectUrl, isBlankListLogin = false) {
    const { appStore } = store;

    let params = new URLSearchParams(window.location.search);

    let token = params.get('token');
    let userId = params.get('userId');
    let openid = params.get('openid');
    let from = params.get('from');
    let platform = params.get('platform');
    let deviceType = params.get('deviceType');
    let authUrl = '/hdc-admin/sys/wc-authorize?targetUrl=';
    let shareCodePanorama = params.get('shareCodePanorama');
    let shareCode = params.get('shareCode');
    let shareDesignId = params.get('shareDesignId');

    const { pathname } = window.location;

    if (BLANK_LIST.some(v => pathname.includes(v)) && !isBlankListLogin) {
        cb?.();
        return;
    }

    if (
        shareCodePanorama ||
        (shareCode && from !== 'miniprogram') ||
        shareDesignId
    ) {
        cb?.();
        return;
    }

    if (pathname === '/apple-app-site-association' || pathname === '/app/') {
        cb?.();
        return;
    }

    if (pathname.includes('login') && openid && !token) {
        cb?.();
        return;
    }

    const isPhone =
        ['android', 'ios'].includes(platform) &&
        ['phone', 'pad'].includes(deviceType);

    if (
        (pathname.includes('login') || pathname.includes('appLogin')) &&
        isPhone
    ) {
        cb?.();
        return;
    }

    // 缓存中有token且 URL有token 且 在APP端 ：直接忽略缓存的token使用URL的token
    if (token && appStore.isLogIn && isPhone) {
        if (userId) {
            appStore.setLoginData({ token, userinfo: { userId } });
        } else {
            appStore.setLoginData({ token });
        }

        cb?.();
        return;
    }

    if (appStore.isLogIn) {
        cb?.();
    } else if (token) {
        appStore.setLoginData({ token, userinfo: { userId } });
        cb?.();
        if (from === 'freeUse') {
            Taro.showLoading({
                title: intl.get('commonUtils.login'),
                mask: true,
            });
            handleCreateProject().finally(() => {
                Taro.hideLoading();
            });
        } else if (window.location.pathname.includes('login')) {
            Taro.navigateTo({
                url: 'pages/home/index',
            });
        }
    } else if (!window.location.href.includes(authUrl)) {
        window.location.href = `${authUrl}${encodeURIComponent(
            redirectUrl || window.location.href
        )}`;
    } else {
        Taro.showToast({
            title: intl.get('commonUtils.openIdError'),
            icon: 'none',
        });
    }
}

//调用 wxResourceidToFile 的页面，需要自行对 jssdk 初始化
/*
参数：resourceidArr 格式如：["weixin://resourceid/3a35e801c84a8d885ce6edd423df5993","weixin://resourceid/193124946d86dea1c906d235c8ea0d6b"]

*/
function wxResourceidToFile(resourceidArr, pUploadCallBackFn) {
    let retArr = [];

    resourceidArr.map(function (resourceid) {
        let retItem = { resourceid };

        wx.getLocalImgData({
            localId: resourceid, // 图片的localID
            success: function (res) {
                var localData = res.localData; // localData是图片的base64数据，可以用img标签显示

                //判断是否有这样的头部，没有的话加上
                if (localData.indexOf('data:image') != 0) {
                    localData = 'data:image/jpeg;base64,' + localData;
                }

                //第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
                //这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg
                localData = localData
                    .replace(/\r|\n/g, '')
                    .replace('data:image/jgp', 'data:image/jpeg');
                let contentType = localData.split(';base64,')[0].split(':')[1];
                let ext = contentType.split('/')[1];

                retItem.base64Data = {
                    dataURL: localData,
                    type: contentType,
                    ext: ext,
                };

                let blobData = convertBase64UrlToBlob(retItem.base64Data);

                retItem.blobData = new File(
                    [blobData],
                    createUUID().slice(-6) + '.' + ext,
                    { type: contentType }
                );

                retArr.push(retItem);

                if (retArr.length === resourceidArr.length) {
                    console.log(
                        'zz wxResourceidToFile getLocalImgData  retArr',
                        retArr
                    );
                    pUploadCallBackFn(retArr);
                }
            },
            fail: function (res) {
                console.log('zx wxResourceidToFile getLocalImgData fail', res);
            },
        });
    });
}

function isWeixin() {
    //判断是否是微信浏览器
    let ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger';
}

function isIOSSystem() {
    if (Taro.getSystemInfoSync().system) {
        return Taro.getSystemInfoSync().system === IOSSystemStr;
    } else {
        return (
            (/macintosh|mac os x/i.test(navigator.userAgent) &&
                window.screen.height > window.screen.width &&
                !navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)) ||
            navigator.userAgent.match(/(iPad).*OS\s([\d_]+)/)
        );
    }
}

const getImgPreviewUrl = async params => {
    try {
        const res = await commentAdjunctView(params);
        if (res.code === 0) {
            return res.data.url;
        } else {
            return '';
        }
    } catch (e) {
        console.log(e);
    }
};

const getListPreviewUrl = async (list, projectId, currentData) => {
    const promiseList = list.map(async item => {
        const thumbUrl = await getImgPreviewUrl({
            adjunctId: item.id,
            path: item.url,
            projectId,
        });
        return { ...item, thumbUrl };
    });
    const urlList = await Promise.all(promiseList);
    const current = urlList.filter(item => item.id === currentData.id)[0]
        .thumbUrl;

    return { urlList, current };
};

function getDateTimeObject(date) {
    date = date instanceof Date ? date : new Date();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let dayOfWeek = date.getDay();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    let milli = date.getMilliseconds();
    let tzOffset = -date.getTimezoneOffset() / 60;
    let tzHour = parseInt(tzOffset, 10);
    let tzMinute = Math.abs((tzOffset - tzHour) * 60);

    return {
        year: year,
        month: month,
        day: day,
        dayOfWeek: dayOfWeek,
        hour: hour,
        minute: minute,
        second: second,
        milliseconds: milli,
        tzHour: tzHour,
        tzMinute: tzMinute,
    };
}

function getPDFLicense() {
    return {
        licenseSN: PDF_SN,
        licenseKey: PDF_KEY,
    };
}

function getQueryVariable(variable, url, defaultValue) {
    let query = window.location.search.substring(1);
    if (url) {
        query = url.substring(url.indexOf('?' + 1));
    }
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (pair[0] === variable) {
            let value = decodeURIComponent(pair[1]);
            return value;
        }
    }
    return defaultValue !== void 0 ? defaultValue : null;
}

function copyText(text) {
    let promise = () => {
        let textArea = document.createElement('input');
        textArea.value = text;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        selectText(textArea, 0, textArea.value.length);
        return new Promise((res, rej) => {
            document.execCommand('copy') ? res() : rej('不兼容');
            textArea.remove();
        });
    };

    const selectText = (input, startIndex, stopIndex) => {
        if (input.setSelectionRange) {
            input.setSelectionRange(startIndex, stopIndex);
            input.focus();
        } else if (input.createTextRange) {
            const range = input.createTextRange();
            range.collapse(true);
            range.moveStart('character', startIndex);
            range.moveEnd('character', stopIndex - startIndex);
            range.select();
        }
    };

    if (navigator.permissions) {
        return navigator.permissions
            .query({ name: 'clipboard-write' })
            .then(result => {
                if (result.state === 'granted') {
                    if (navigator.clipboard) {
                        return navigator.clipboard.writeText(text);
                    }
                    return promise();
                } else {
                    return promise();
                }
            })
            .catch(() => promise());
    } else {
        return promise();
    }
}

function whichEnv() {
    const envGroup = window.location.host.match(new RegExp(/^m(?:-)?(\w*).*$/));
    if (envGroup && envGroup[1]) {
        return envGroup[1];
    } else if (envGroup && !envGroup[1]) {
        return 'prod';
    } else {
        return 'dev';
    }
}

//  调用微信客服
const callWeChatService = (callName = 'openWeixinService') => {
    try {
        externalDispatchFun(
            'HDC',
            callName,
            JSON.stringify({
                cropid: 'ww2a506696155f286d',
                kfurl: 'https://work.weixin.qq.com/kfid/kfccfd94e11343513bc',
            })
        );
    } catch { }
};

function findDevice(needle) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf(needle) !== -1;
}

function isIpad() {
    // ios 平板
    const iPadOS13Up =
        window.navigator.platform === 'MacIntel' &&
        window.navigator.maxTouchPoints > 1;
    return findDevice('ipad') || iPadOS13Up;
}

function isAndroidTablet() {
    // android 平板
    return findDevice('android') && !findDevice('mobile');
}

function getAndroidPanoramaScreen(platform, panoramaRef) {
    return new Promise(resolve => {
        if (platform === 'android') {
            const { renderer, scene, camera } =
                panoramaRef.current.viewer.current;

            renderer.render(scene, camera);

            //只保留 nav-bar-full-house、nav-bar、webgl
            try {
                const container = document.getElementsByClassName('excellent-design-3d')[0];
                const webglCanvas = renderer.domElement;
                const webglDataUrl = webglCanvas.toDataURL('image/jpeg', 0.6);

                if (container) {
                    const titleNode = document.querySelector('.nav-bar-full-house');
                    const thumbNode = document.querySelector('.nav-bar');

                    if (!titleNode && !thumbNode) {
                        console.warn('target UI nodes not found');
                        resolve(webglDataUrl);
                        return;
                    }

                    const containerRect = container.getBoundingClientRect();
                    const markAttr = 'data-screen-shot-target';
                    let isMarked = false;
                    let isSettled = false;

                    const cleanMarks = () => {
                        if (!isMarked) return;
                        webglCanvas?.removeAttribute(markAttr);
                        titleNode?.removeAttribute(markAttr);
                        thumbNode?.removeAttribute(markAttr);
                        isMarked = false;
                    };

                    const finalize = data => {
                        if (isSettled) return;
                        isSettled = true;
                        cleanMarks();
                        resolve(data);
                    };

                    webglCanvas?.setAttribute(markAttr, 'webgl');
                    titleNode?.setAttribute(markAttr, 'title');
                    thumbNode?.setAttribute(markAttr, 'thumb');
                    isMarked = true;

                    let capturePromise;
                    try {
                        capturePromise = html2canvas(container, {
                            width: containerRect.width,
                            height: containerRect.height,
                            scale: 1,
                            useCORS: true,
                            backgroundColor: null,
                            logging: false,
                            removeContainer: true,
                            scrollX: -window.scrollX,
                            scrollY: -window.scrollY,
                            onclone: clonedDoc => {
                                const clonedWebgl = clonedDoc.querySelector(
                                    `[${markAttr}="webgl"]`
                                );
                                if (clonedWebgl) {
                                    const cloneWidth = clonedWebgl.clientWidth;
                                    const cloneHeight = clonedWebgl.clientHeight;
                                    const img = clonedDoc.createElement('img');
                                    img.src = webglDataUrl;
                                    img.className = clonedWebgl.className;
                                    img.style.cssText = clonedWebgl.style.cssText;
                                    img.style.width = `${cloneWidth}px`;
                                    img.style.height = `${cloneHeight}px`;
                                    img.style.display = 'block';
                                    clonedWebgl.parentNode?.replaceChild(img, clonedWebgl);
                                }

                                const clonedTitle = clonedDoc.querySelector(
                                    `[${markAttr}="title"]`
                                );
                                if (clonedTitle) {
                                    clonedTitle.style.transition = 'none';
                                    clonedTitle.style.animation = 'none';
                                    clonedTitle.style.webkitTextSizeAdjust = '100%';
                                    clonedTitle.style.textSizeAdjust = '100%';
                                }
                            },
                            ignoreElements: ele => {
                                if (ele.id === '__vconsole') return true;
                                if (
                                    typeof ele.className === 'string' &&
                                    ele.className.includes('vconsole')
                                )
                                    return true;

                                const target = ele.getAttribute?.(markAttr);
                                if (
                                    target === 'webgl' ||
                                    target === 'title' ||
                                    target === 'thumb'
                                ) {
                                    return false;
                                }

                                if (ele.closest?.(`[${markAttr}]`)) return false;
                                if (ele.querySelector?.(`[${markAttr}]`)) return false;

                                return true;
                            },
                        });
                    } catch (err) {
                        console.error('html2canvas call error', err);
                        finalize();
                        return;
                    }

                    capturePromise
                        .then(canvas => {
                            try {
                                finalize(canvas.toDataURL('image/jpeg', 0.4));
                            } catch (err) {
                                console.error('canvas toDataURL error', err);
                                finalize(webglDataUrl);
                            }
                        })
                        .catch(err => {
                            console.error('html2canvas target-only error', err);
                            finalize(webglDataUrl);
                        });
                } else {
                    resolve(webglDataUrl);
                }
            } catch (e) {
                console.error('getAndroidPanoramaScreen error', e);
                resolve(null);
            }

            
        } else {
            resolve(null);
        }
    });
}

const queryUserInfoOnline = async () => {
    try {
        const res = await getUserInfo();
        return res;
    } catch (e) { }
};

const isSafari = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return (
        userAgent.indexOf('safari') !== -1 &&
        userAgent.indexOf('chrome') === -1 &&
        userAgent.indexOf('firefox') === -1
    );
};

const htmlAndBodyNoScroll = isNoScroll => {
    let html = document.documentElement;
    let body = document.body;

    if (isNoScroll) {
        html.classList.add('no-scroll');
        body.classList.add('no-scroll');
    } else {
        html.classList.remove('no-scroll');
        body.classList.remove('no-scroll');
    }

    html = null;
    body = null;
};

export {
    getTimeStr,
    getTimeStrFormat,
    getSynergyUrl,
    getFileBaseUrl,
    handleLogin,
    isWeixin,
    isIOSSystem,
    wxResourceidToFile,
    getImgPreviewUrl,
    getListPreviewUrl,
    getDateTimeObject,
    getPDFLicense,
    getPayWsUrl,
    getQueryVariable,
    copyText,
    whichEnv,
    callWeChatService,
    isIpad,
    isAndroidTablet,
    getAndroidPanoramaScreen,
    queryUserInfoOnline,
    findDevice,
    isSafari,
    htmlAndBodyNoScroll,
};
